import { get } from './apiUtil';
import { OverrideReason } from '../model/override-reason';

export async function getOverrideReasons(): Promise<OverrideReason[]> {
  const response = await get('/api/eaus/v1/reasons');
  return response.data as OverrideReason[];
}
